module.exports = __webpack_public_path__ + "img/202310_02.02e3eca5.jpg";